<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g id="digitaler_helfer_leerstand_pfad">
      <g>
        <circle cx="22.71" cy="38.8" r="1.32" fill="currentcolor"/>
        <path d="M22.71,40.62c-1,0-1.82-.82-1.82-1.82s.82-1.82,1.82-1.82h0c1,0,1.82.82,1.82,1.82s-.82,1.82-1.82,1.82ZM22.71,37.98c-.45,0-.82.37-.82.82s.37.82.82.82.82-.37.82-.82-.37-.82-.82-.82Z" fill="currentcolor"/>
      </g>
      <path d="M34.44,34.79H11.03s-.09-29.51-.09-29.51h23.5s0,29.51,0,29.51ZM14.02,31.78h17.42s0-23.51,0-23.51H13.95s.07,23.51.07,23.51Z" fill="currentcolor"/>
      <path d="M9.11,44.96c-.4,0-.78-.16-1.06-.44l-2.14-2.14c-.28-.28-.44-.66-.44-1.06l.05-37.59c0-.38.15-.75.41-1.03.38-.41.63-.71.87-1.01.28-.35.57-.7,1.02-1.18.28-.3.68-.47,1.09-.47h0l29.11.04c.4,0,.78.16,1.06.44.28.28.44.66.44,1.06l-.13,41.87c0,.4-.16.78-.44,1.06-.28.28-.66.44-1.06.44h-2.04s-26.75,0-26.75,0h0ZM8.47,40.71l1.26,1.26,24.78-.02h1.35s.54,0,.54,0l.12-38.87-26.94-.04c-.17.19-.3.36-.44.54-.19.23-.38.47-.61.74l-.05,36.39Z" fill="currentcolor"/>
    </g>
  </svg>
</template>

<style scoped lang="scss">

</style>